<template>
  <div class="ac1">
    <!-- 标题 -->
    <div class="ac1-title">
      <h2>热门新闻</h2>
    </div>
    <!-- 主容器 -->
    <div class="ac1-list">
      <!-- 循环项 -->
      <div
        class="ac1-item"
        v-for="(item, index) in data"
        :key="index"
        @click="gopay()"
      >
        <!-- 图片 -->
        <div class="item-img">
          <img :src="item.img" alt="" />
        </div>
        <!-- 标题 -->
        <p>{{ item.title }}</p>
      </div>
    </div>
    <modal
      title="请微信扫码支付"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img
          style="display: flex; justify-content: center; margin: 0 auto"
          src="/imgs/pay2.png"
        />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac1",
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      showModal: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.axios.get("/mock/ac1.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.data = data.splice(6, 3);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
       alert("资讯收费2元，请扫码购买~");
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac1 {
  width: 100%;
  margin-bottom: 30px;
  // height: 400px;
  // background-color: #c60023;
  // 标题
  .ac1-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;
    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
    }
  }

  // 主容器
  .ac1-list {
    width: 100%;
    // padding: 30px;
    box-sizing: border-box;
    height: 220px;
    // background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // 循环项
    .ac1-item {
      width: 300px;
      height: 200px;
      background-color: #fff;
      .item-img {
        width: 100%;
        height: 160px;
        padding: 10px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
        }
      }

      P {
        // width: 100%;
        width: 235px;
        height: 40px;
        text-align: center;
        font-size: 12px;
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>